import { TemplateHelpPlanModel } from "./template-help-plan.model";

export class TemplateModel{
    tlId: string;
    tlTemplateName: string;
    tlTemplateLanguage: string;
    templateHelpPlans: TemplateHelpPlanModel[]=[];
}